import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DetailPair } from '../../../../../../../shared/components/detail-info-card/DetailPair';
import { DataUtility } from '../../../../../../../utilities/DataUtility';
import { EquifaxDetailCardComponent } from '../equifax-detail-card/equifax-detail-card.component';

@Component({
  selector: 'app-guest-phone-result-card',
  templateUrl: './guest-phone-result-card.component.html',
  styleUrls: ['./guest-phone-result-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    EquifaxDetailCardComponent
  ]
})
export class GuestPhoneResultCardComponent implements OnInit {

  @Input() guest!: any;

  data: DetailPair[] = [];
  title = 'Phone Trust';
  trustDecision!: string;

  phoneAffiliationReason!: string;
  phoneVerificationReason!: string;
  phoneInsightsReason!: string;

  constructor(private readonly dataUtility: DataUtility) { }

  ngOnInit() {
    this.phoneAffiliationReason = this.dataUtility.getCheckReason(this.guest, 'phoneAffiliationReason');
    this.phoneVerificationReason = this.dataUtility.getCheckReason(this.guest, 'phoneVerificationReason');
    this.phoneInsightsReason = this.dataUtility.getCheckReason(this.guest, 'phoneInsightsReason');

    this.populatePhoneTrustInfo();
  }

  populatePhoneTrustInfo() {
    this.trustDecision = this.dataUtility.getTrustInfo(this.guest, 'phoneTrust');

    this.data.push(new DetailPair("Affiliation", this.dataUtility.getTrustInfo(this.guest, 'phoneAffiliation') ? this.dataUtility.getTrustInfo(this.guest, 'phoneAffiliation') : null, this.phoneAffiliationReason));
    this.data.push(new DetailPair("Verification", this.dataUtility.getTrustInfo(this.guest, 'phoneVerification') ? this.dataUtility.getTrustInfo(this.guest, 'phoneVerification') : null, this.phoneVerificationReason));
    this.data.push(new DetailPair("Insights", this.dataUtility.getTrustInfo(this.guest, 'phoneInsights') ? this.dataUtility.getTrustInfo(this.guest, 'phoneInsights') : null, this.phoneInsightsReason));
  }

}